"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const useSchedule_1 = require("../useSchedule");
const Table = styled_1.default.table `
  line-height: ${constants_1.theme.lineHeight.normal};
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  height: 0;
  border-bottom: 1px solid ${constants_1.Color.GREY};
  background-color: ${constants_1.Color.WHITE};

  width: ${(props) => props.isMultipleWeeks
    ? `${props.headerColumnWidth + props.columnCount * props.columnWidth}px` // Total width = fixed column + day columns: ;
    : '100%'};

  col:first-of-type {
    width: ${(props) => props.headerColumnWidth}px; // Fixed width for the first column
  }

  ${(props) => props.isMultipleWeeks &&
    `
    col:not(:first-of-type) {
      width: ${props.columnWidth}px; // Fixed width for day columns when multiple weeks
    }
  `}

  td {
    padding: 4px;
    vertical-align: top;
  }
`;
const Grid = (props) => {
    const { days, headerColumnWidth, columnWidth, columnCount } = (0, useSchedule_1.useSchedule)();
    return ((0, jsx_runtime_1.jsx)(Table, { isMultipleWeeks: days.length > 7, columnCount: columnCount, headerColumnWidth: headerColumnWidth, columnWidth: columnWidth, children: props.children }));
};
exports.Grid = Grid;
